/**
 * local storage management
 * it uses the localStorage and JSON objects. Works in IE8.
 * @return {Object}
 * @throws Error
 */
const localstorageManager = (items) => {
    // detect HTML5 functionality
    if (!('localStorage' in window && window['localStorage'] !== null) && !('JSON' in window && window['JSON'] !== null)) {
        throw new Error("localstorage not supported")
    }

    var list = JSON.parse(localStorage.getItem(items)) || {}

    /**
     * saves the stringified JSON to the local storage
     */
    function save() {
        try {
            localStorage.setItem(items, JSON.stringify(list))
        } catch (e) {
            // local storage not supported, no fallback
        }
    }

    /**
     * adds the given key-value-pair to the local storage
     * @param key
     * @param value
     */
    function store(key, value) {
        list[key] = value
        save()
    }

    /**
     * deletes an item by its key
     * @param key
     */
    function clear(key) {
        delete list[key]
        if (0 >= list.length) {
            localStorage.removeItem(items)
        } else {
            save()
        }
    }

    /**
     * get the list as JSON, parses local storage string to make sure that latest data is returned
     * @return {*|Object}
     */
    function getItem(key) {
        //list = JSON.parse(localStorage.getItem(itemName))
        if ("undefined" !== typeof list && null !== list) {
            if (list.hasOwnProperty(key)) {
                return list[key]
            } else {
                return list
            }
        } else {
            return {}
        }
    }

    function getItems() {
        return list
    }

    return {
        store: store,
        clear: clear,
        getItem: getItem,
        getItems: getItems
    }
}

export default localstorageManager